import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';

export default class UpdateTicketSubjectDialog extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.ticket = this.attrs.ticket;

    this.name = Stream(this.ticket.title() || '');

    this.redirect = this.attrs.redirect;
  }

  className() {
    return 'Modal--small Support-Modal';
  }

  title() {
    return app.translator.trans('v17development-flarum-support.forum.tickets.tools.update_subject');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">{this.fields().toArray()}</div>
      </div>
    );
  }

  fields() {
    const items = new ItemList();

    items.add(
      'name',
      <div className="Form-group">
        <label>{app.translator.trans('v17development-flarum-support.forum.tickets.fields.subject.placeholder')}:</label>
        <input
          className="FormControl"
          placeholder={app.translator.trans('v17development-flarum-support.forum.tickets.fields.subject.title')}
          bidi={this.name}
        />
      </div>,
      50
    );

    items.add(
      'submit',
      <div className="Form-group">
        {Button.component(
          {
            type: 'submit',
            className: 'Button Button--primary SupportModal-save',
            loading: this.loading,
          },
          'Update'
        )}
      </div>,
      -10
    );

    return items;
  }

  submitData() {
    return {
      title: this.name(),
    };
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    this.ticket
      .save({
        title: this.name(),
      })
      .then(
        () => {
          this.hide();

          // Redirect
          if (this.redirect) {
            const url = `/knowledgebase/${this.ticket.id()}-${this.slug()}`;

            m.route.set(url, true);
            window.history.replaceState(null, document.title, url);
          }
        },
        (response) => {
          this.loading = false;
          this.handleErrors(response);
        }
      );
  }
}
